import * as React from 'react'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const ContactForm = dynamic(() => import('@components/ContactForm'))
const Meta = dynamic(() => import('@components/Meta'))

export default function Contact() {
  const [isSmallDevices, setIsSmallDevices] = React.useState(true)

  React.useEffect(() => {
    const mql = window.matchMedia('(max-width: 750px)')
    setIsSmallDevices(mql.matches)
  }, [])

  return (
    <React.Fragment>
      <Meta title={`${t('pages.contact.title')} – ${t('layout.title')}`} />

      <div className='Contact'>
        <div className='container'>
          <div className='Contact__header'>
            <h1>
              ติดต่อ<span>เรา</span>
            </h1>
          </div>

          <div className='Contact__left'>
            <div className='Contact__branch'>
              <h3>สำนักงานใหญ่</h3>
              <p>
                1778 อาคาร Summer Hub Offices ชั้นที่ 6 ถนนสุขุมวิท แขวงพระโขนง
                เขตคลองเตย กรุงเทพ 10110
              </p>

              <a href='tel:020245560'>
                <span>โทร: </span>
                <small>02-024-5560</small>
              </a>
              <br />
              <a href='mailto:sales@datawow.io' title='sales@datawow.io'>
                sales@datawow.io
              </a>

              <div className='Contact__map'>
                {isSmallDevices ? (
                  <>
                    <img src='/images/map-th.jpg' alt='map' loading='lazy' />
                    <div>
                      <span>Data Wow</span>
                      <a
                        href='https://maps.google.com/maps?ll=13.714077,100.592091&z=15&t=m&hl=en&gl=TH&mapclient=embed&cid=18308278239524073295'
                        target='_blank'
                        rel='nofollow noopener noreferrer'
                        title='View larger map'
                      >
                        View larger map
                      </a>
                    </div>
                  </>
                ) : (
                  <iframe
                    className='Contact__iframe'
                    src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.072195349628!2d100.58990201483007!3d13.714077190371894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29feb33e83421%3A0xfe14120eb3d8af4f!2sData%20Wow!5e0!3m2!1sen!2sth!4v1585543617852!5m2!1sen!2sth'
                    frameBorder='0'
                    allowFullScreen
                    loading='lazy'
                    width='490'
                    height='200'
                  />
                )}
              </div>
            </div>

            <div className='Contact__branch Contact__branch--jp'>
              <h3>
                Tokyo Branch
                <img src='/images/icon-japan.svg' alt='Japan' />
                <small>Nanameue inc</small>
              </h3>
              <address>
                Shiroyama Trust Tower 21F, 4-3-1 Toranomon, Minato-ku, Tokyo, 105-6021, Japan
              </address>

              <div className='Contact__links'>
                <a href='tel:81367211076'>Tel: +81-3-6721-1076</a>
                <a href='mailto:ai@nanameue.jp '>Email: ai@nanameue.jp </a>
              </div>

              <div className='Contact__map'>
                {isSmallDevices ? (
                  <>
                    <img src='/images/map-jp.jpg' alt='map' loading='lazy' />
                    <div>
                      <span>nanameue, Inc.</span>
                      <a
                        href='https://maps.google.com/maps?ll=35.670033,139.730281&z=15&t=m&hl=en&gl=TH&mapclient=embed&cid=17370901515615049473'
                        target='_blank'
                        rel='nofollow noopener noreferrer'
                        title='View larger map'
                      >
                        View larger map
                      </a>
                    </div>
                  </>
                ) : (
                  <iframe
                    src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.2830169768354!2d139.7280926153395!3d35.670032680196876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b5611315555%3A0xf111d6e4ba879701!2snanameue%2C%20Inc.!5e0!3m2!1sen!2sth!4v1610341396801!5m2!1sen!2sth'
                    frameBorder='0'
                    allowFullScreen
                    loading='lazy'
                    width='490'
                    height='200'
                  />
                )}
              </div>
            </div>
          </div>

          <div className='Contact__right'>
            <div>
              <h3>สอบถามข้อมูล หรือรับคำปรึกษาได้ที่นี่</h3>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Contact.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}
